import { Button } from "@/components/ui/button.js"

/**
 * The two-step confirm an in-row action swaps to: the prompt, a button that
 * does it, a button that does not. Nothing here opens a dialog — the row that
 * was clicked is the row that asks, so the eye never leaves the thing it is
 * about to change. On failure the prompt becomes the error text, in the risk
 * colour, and both buttons stay so the person can try again or back out.
 *
 * Shared by every irreversible-enough action in the panel: rotating or
 * deactivating an API key, revoking an override.
 */
export function Confirm({
  prompt,
  pending,
  error,
  onConfirm,
  onCancel,
}: {
  prompt: string
  pending: boolean
  error: unknown
  onConfirm: () => void
  onCancel: () => void
}) {
  const message = error ? (error instanceof Error ? error.message : "Nie udało się.") : prompt
  return (
    <div className="flex items-center justify-end gap-2">
      <span className={`text-[13px] ${error ? "text-critical" : "text-muted-foreground"}`}>
        {message}
      </span>
      <Button size="sm" disabled={pending} onClick={onConfirm}>
        {pending ? "…" : "Potwierdź"}
      </Button>
      <Button size="sm" variant="ghost" disabled={pending} onClick={onCancel}>
        Anuluj
      </Button>
    </div>
  )
}
